import React from 'react';
import clsx from 'clsx';
import {createStyles, makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import AppLogo from "../AppLogo/AppLogo";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import {Button, Drawer, SwipeableDrawer, Tooltip, Typography} from "@material-ui/core";
import {Link} from 'react-router-dom';

const drawerWidth = 240;
//
// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             display: 'flex',
//         },
//         appBar: {
//             transition: theme.transitions.create(['margin', 'width'], {
//                 easing: theme.transitions.easing.sharp,
//                 duration: theme.transitions.duration.leavingScreen,
//             }),
//         },
//         appBarShift: {
//             width: `calc(100% - ${drawerWidth}px)`,
//             transition: theme.transitions.create(['margin', 'width'], {
//                 easing: theme.transitions.easing.easeOut,
//                 duration: theme.transitions.duration.enteringScreen,
//             }),
//             marginRight: drawerWidth,
//         },
//         title: {
//             flexGrow: 1,
//         },
//         hide: {
//             display: 'none',
//         },
//         drawer: {
//             width: drawerWidth,
//             flexShrink: 0,
//         },
//         drawerPaper: {
//             width: drawerWidth,
//         },
//         drawerHeader: {
//             display: 'flex',
//             alignItems: 'center',
//             padding: theme.spacing(0, 1),
//             // necessary for content to be below app bar
//             ...theme.mixins.toolbar,
//             justifyContent: 'flex-start',
//         },
//         drawerOpen: {
//             width: drawerWidth,
//             transition: theme.transitions.create('width', {
//                 easing: theme.transitions.easing.sharp,
//                 duration: theme.transitions.duration.enteringScreen,
//             }),
//         },
//         drawerClose: {
//             transition: theme.transitions.create('width', {
//                 easing: theme.transitions.easing.sharp,
//                 duration: theme.transitions.duration.leavingScreen,
//             }),
//             overflowX: 'hidden',
//             width: theme.spacing(7) + 1,
//             [theme.breakpoints.up('sm')]: {
//                 width: theme.spacing(9) + 1,
//             },
//         },
//         content: {
//             flexGrow: 1,
//             padding: theme.spacing(3),
//             transition: theme.transitions.create('margin', {
//                 easing: theme.transitions.easing.sharp,
//                 duration: theme.transitions.duration.leavingScreen,
//             }),
//             marginRight: -drawerWidth,
//         },
//         contentShift: {
//             transition: theme.transitions.create('margin', {
//                 easing: theme.transitions.easing.easeOut,
//                 duration: theme.transitions.duration.enteringScreen,
//             }),
//             marginRight: 0,
//         },
//         sectionDesktop: {
//             display: 'none',
//             [theme.breakpoints.up('md')]: {
//                 display: 'flex',
//             },
//         },
//     }),
// );
type Anchor = 'top' | 'left' | 'bottom' | 'right';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            zIndex: theme.zIndex.drawer + 1,
            transition: theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            width: `calc(100% - ${drawerWidth}px)`,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: drawerWidth,
        },
        menuButton: {
            marginRight: 36,
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',

        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9) + 1,
            },
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
            justifyContent: 'flex-start',
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: theme.spacing(0, 1),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        title: {
            flexGrow: 1,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginRight: 0,
        },


    }),
);

export default function Dashboard(props: any) {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const toggleDrawer = (anchor: Anchor, open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setState({...state, [anchor]: open});
    };


    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <div className={classes.title}>
                        <AppLogo/>
                    </div>
                    <Typography variant="h6" color={'primary'}>
                        <Button className={classes.menuButton} component={Link} to={'/'}>HOME</Button>
                        <Button className={classes.menuButton} component={Link} to={'/admin'}>ADMIN</Button>
                        <Button className={classes.menuButton} component={Link} to={'/parent'}>PARENT</Button>
                        <Button className={classes.menuButton} component={Link} to={'/kid'}>KID</Button>
                    </Typography>
                    <div className={classes.sectionDesktop}>
                        <IconButton aria-label="show 4 new mails" color="inherit">
                            <Badge badgeContent={4} color="secondary">
                                <MailIcon/>
                            </Badge>
                        </IconButton>
                        <IconButton aria-label="show 17 new notifications" color="inherit">
                            <Badge badgeContent={17} color="secondary">
                                <NotificationsIcon/>
                            </Badge>
                        </IconButton>
                    </div>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        onClick={handleDrawerOpen}
                        className={clsx(open && classes.hide)}
                    >
                        <MenuIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: open,
                })}
            >
                <div className={classes.drawerHeader}/>
                {props.children}

            </main>
            <Drawer
                // className={classes.drawer}
                variant="permanent"
                anchor="right"
                open={open}
                // onClose={toggleDrawer('right', false)}
                // onOpen={toggleDrawer("right", true)}
                // // classes={{
                //     paper: classes.drawerPaper,
                // }}
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                {/*<div className={classes.drawerHeader}>*/}
                {/*    <IconButton onClick={handleDrawerClose}>*/}
                {/*        {theme.direction === 'rtl' ? <ChevronLeftIcon/> : <ChevronRightIcon/>}*/}
                {/*    </IconButton>*/}
                {/*</div>*/}
                {/*<Divider/>*/}
                <div className={classes.toolbar}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'rtl' ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
                    </IconButton>
                </div>
                <Divider/>

                <List>
                    {props.menu.map((menuItem: any) => (
                        <ListItem button key={menuItem.title}>
                            <Tooltip title={menuItem.title}>
                                <ListItemIcon>{menuItem.icon}</ListItemIcon>
                            </Tooltip>
                            <ListItemText primary={menuItem.title}/>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
        </div>
    );
}
